import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import AppleStore from '../images/apple-store-light.svg';
import GoogleStore from '../images/google-play-light.svg';
import './StoreBadges.scss';

const storeBadgesQuery = graphql`
  query {
    settings: prismicSiteSett {
      data {
        google_play_url {
          url
        }
        restuarant_google_play_url {
          url
        }
        apple_app_store_url {
          url
        }
        restaurant_apple_app_store_url {
          url
        }
      }
    }
  }
`;

export const StoreBadges = ({ restaurantAppLinks }) => (
  <StaticQuery
    query={storeBadgesQuery}
    render={data => {
      const {
        apple_app_store_url: appleUrl,
        restaurant_apple_app_store_url: restaurantAppleUrl,
        google_play_url: googleUrl,
        restuarant_google_play_url: restaurantGoogleUrl,
      } = data.settings.data;
      const apple = restaurantAppLinks ? restaurantAppleUrl.url : appleUrl.url;
      const google = restaurantAppLinks ? restaurantGoogleUrl.url : googleUrl.url;
      return (
        <div className="store-badges">
          <a href={apple} target="_blank" rel="noreferrer noopener nofollow">
            <img src={AppleStore} alt="Download on the App Store" />
          </a>
          <a href={google} target="_blank" rel="noreferrer noopener nofollow">
            <img src={GoogleStore} alt="Download on Google Play" />
          </a>
        </div>
      );
    }}
  />
);
